import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  decryptData,
  encryptData,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import Loader from "../../../Components/Common/Loader";
import SmallLoader from "../../../Components/Common/smallLoader";
import TradeSummary from "../../../Components/ReportTables/TradeSummary";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import FromdateComponent from "../../Reports/FromdateComponent";
import TodateComponent from "../../Reports/TodateComponent";
import { toast } from "react-toastify";
import { Partner_Reports } from "../../../Configuration/Partner_URL";
import DurationChangeComponent from "../../Reports/DurationChangeComponent";
import { logDOM } from "@testing-library/dom";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function TradeSummaryNew(props) {
  // const seg = props.seg;
  const storeToken = localStorage.getItem("ssoToken");
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const partnerRoleNew = localStorage.getItem("partnerRoleNew");
  const [data, setData] = useState();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [seg, setSeg] = useState("stocks");
  const [errorGrid, setErrorGrid] = useState(false);
  const [selection, setSelection] = useState("date");
  const [customShow, setCustomShow] = useState(false)
  const [totalValues, setTotalValues] = useState({
    totaBuylValue: 0,
    totalSellValue: 0,
    totalNetValue: 0,
  });
  const [errorResp, setErrorResp] = useState("");
  const ClientId2 = localStorage.getItem("ClientId2");
  if (fromDate == "" && toDate == "") {
    // const current = new Date();
    // const CurrentYear = current.getFullYear();
    // const CurrentMonth = current.getMonth();
    // if (CurrentMonth < 4) {
    //   const newYear = `04-01-${CurrentYear - 1}`;
    //   const date = `${
    //     current.getMonth() + 1
    //   }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // } else {
    //   const newYear = `04-01-${CurrentYear}`;
    //   const date = `${
    //     current.getMonth() + 1
    //   }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // }
    let date = new Date();
    let firstDay = "";
    let lastDay = "";
    let firstVal = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
    let lastVal = new Date();
    lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
    setFromDate(firstDay)
    setToDate(lastDay)
  }

  let clientCode = "";
  const getTradeSumaaryReport = async (
    fileView,
    mainLoader = false,
    clientCode
  ) => {
    setSmallLoaderExcel(fileView === "excel");
    setSmallLoaderPdf(fileView === "pdf");
    setSmallLoaderMail(fileView === "mail");
    setLoader(mainLoader && fileView === "grid");
    let payloadValue = {
      clientCode: clientCode || ClientId2,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileView,
      seg: seg,
      selection: selection,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.TradeSummary_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileView === "grid") {
          if (selection === "script") {
            setTotalValues({
              totaBuylValue: res?.data?.totaBuylValue,
              totalSellValue: res?.data?.totalSellValue,
              totalNetValue: res?.data?.totalNetValue,
            });
          }
          if (seg === "stocks") {
            setData(res?.data?.eqList);
          } else if (seg === "curfo") {
            setData(res?.data?.curFoList);
          } else {
            setData(res?.data?.foList);
          }
          if (selection === "script" && seg === "curfo") {
            setData(res?.data?.curScriptFoList);
          }
        } else if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileView === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        } else {
          toast.success("Mail sent successfully");
        }
      } else {
        setData([]);
        setTotalValues({});
        if (fileView !== "grid") {
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      setServerError(error?.message);
      if (fileView !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    }
  };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleFromDateChange = (e) => {
    setData([]);
    setErrorGrid(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setErrorResp("");
    setServerError(false);
  };
  const handleToDateChange = (e) => {
    setData([]);
    setErrorGrid(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorResp("");
    setServerError(false);
  };

  useEffect(() => {
    if (localStorage.getItem("clientCode") || ClientId2 !== null) {
      clientCode = localStorage.getItem("clientCode");
      if (
        compareDate(fromDate) &&
        compareDate(toDate) &&
        checkDateRange(fromDate, toDate)
      ) {
        getTradeSumaaryReport("grid", true, clientCode);
      } else {
        setData([]);
        setErrorResp("Please Select Correct Date.");
      }
    }
  }, []);

  const handleOnClick = (e) => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      clientCode = localStorage.getItem("clientCode");
      if (e.target.value) {
        if (
          compareDate(fromDate) &&
          compareDate(toDate) &&
          checkDateRange(fromDate, toDate)
        ) {
          getTradeSumaaryReport(e.target.value, true, clientCode);
          setErrorResp("");
        } else {
          setErrorResp("Please Select Correct Date");
        }
      }
    } else {
      toast.error("Client code not found");
    }
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const handleSelectionChange = (e) => {
    setData([]);
    setErrorGrid(false);
    setServerError(false);
    setSelection(e.target.value);
  };

  const handleSegmentChange = (e) => {
    setData([]);
    setErrorGrid(false);
    setServerError(false);
    setSeg(e.target.value);
  };

  const onChangeDuration = () => {
    setData([]);
    setErrorGrid(false);
    setErrorResp("");
    setServerError(false);
  }
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="trade-summary"
        role="tabpanel"
        aria-labelledby="trade-summary"
      >
        <div className="reports-date-filter">
          <div className="reports-left-form">
            <form>
              <div className="report-form-wrapper">
                <div className="form-group" >
                  <DurationChangeComponent
                    setCustomShow={setCustomShow}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                    className="report-custom-select"
                    screen="Client Dashboard"
                    onChangeDuration={onChangeDuration}
                  />
                </div>
                {customShow && <FromdateComponent
                  fromDate={handleFromDateChange}
                  formatDate={formatDate(fromDate)}
                  DateReverse={DateReverse}
                />}

                {customShow && <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={errorResp}
                />}
              </div>
              <div className="form-group">
                <label className="form-label">Segment:</label>
                <select
                  className="report-custom-select"
                  onChange={handleSegmentChange}
                >
                  <option value="stocks">Equity</option>
                  <option value="fo">Derivative</option>
                  <option value="curfo">{Constants.Currency}</option>
                  <option value="com">Commodity</option>
                  <option value="slbm">SLBM</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Selection:</label>
                <select
                  className="report-custom-select"
                  onChange={handleSelectionChange}
                  style={{ padding: "5px" }}
                >
                  <option value="date">Date</option>
                  <option value="script">Scrip</option>
                </select>
              </div>
            </form>
            <button
              className="generate-button get-data"
              value="grid"
              onClick={handleOnClick}
            >
              {Constants.Submit}
            </button>
          </div>
          <div className="report-btn-wrapper">
            <button
              className="generate-button mail-btn"
              value="mail"
              onClick={handleOnClick}
            >
              {smallLoaderMail ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-email"></span>
                  E-Mail
                </>
              )}
            </button>

            <button
              className="generate-button excel-btn"
              value="excel"
              onClick={handleOnClick}
            >
              {smallLoaderExcel ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {Constants.Excel}
                </>
              )}
            </button>
            <button
              className="generate-button pdf-btn"
              value="pdf"
              onClick={handleOnClick}
            >
              {smallLoaderPdf ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-pdfsvg"></span>
                  {Constants.PDF}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : data && data.length > 0 ? (
        <div>
          <TradeSummary
            data={data}
            seg={seg}
            selection={selection}
            totalValues={totalValues}
          />
        </div>
      ) : serverError ? (
        <h4 className="report-error-message">{noDataFound(serverError)}</h4>
      ) : errorGrid ? (
        noDataFound(errorGrid)
      ) : (
        ""
      )}
    </>
  );
}
export default TradeSummaryNew;
